(function () {
  'use strict';
  if (window.__libasPriceBands) return;
  window.__libasPriceBands = true;
  var bandParam = 'filter.v.m.custom.libas_price_band';
  var priceParams = ['filter.v.price.gte', 'filter.v.price.lte'];

  function patchPriceParams() {
    var renderer = window.theme && window.theme.AjaxRenderer;
    if (!renderer || renderer.prototype.__libasPriceBandParams) return;
    var original = renderer.prototype.getUpdatedParams;
    renderer.prototype.getUpdatedParams = function (existing, incoming) {
      var result = original.call(this, existing, incoming);
      var form = document.querySelector('.filter-form[data-libas-price-mode]');
      if (form && form.dataset.libasPriceMode === 'bands') {
        // The theme deletes while iterating URLSearchParams, which can skip the next
        // removed key. Rebuild only our price keys from the intended request.
        priceParams.concat(bandParam).forEach(function (key) {
          result.delete(key);
          incoming.getAll(key).filter(Boolean).forEach(function (value) {
            result.append(key, value);
          });
        });
        result.delete('page');
      }
      return result;
    };
    renderer.prototype.__libasPriceBandParams = true;
  }
  patchPriceParams();
  document.addEventListener('DOMContentLoaded', patchPriceParams, { once: true });

  function restoreSliderUrl() {
    var form = document.querySelector('.filter-form[data-libas-price-mode]');
    if (!form || form.dataset.libasPriceMode === 'bands') return;
    var url = new URL(window.location.href);
    if (!url.searchParams.has(bandParam)) return;
    url.searchParams.delete(bandParam);
    url.searchParams.delete('page');
    window.location.replace(url.toString());
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreSliderUrl, { once: true });
  } else {
    restoreSliderUrl();
  }
  document.addEventListener('collection:reloaded', restoreSliderUrl);

  // Run before the theme serializes the form; a band replaces a legacy interval.
  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-libas-price-band]')) return;
    var form = event.target.closest('form');
    form.querySelectorAll('[data-libas-legacy-price]').forEach(function (input) {
      input.disabled = true;
    });
    form.dataset.libasBandChanged = 'true';
  }, true);

  document.addEventListener('formdata', function (event) {
    var form = event.target;
    if (!form.matches('.filter-form[data-libas-price-mode]')) return;
    var params = new URLSearchParams(window.location.search);
    ['sort_by', 'filter.p.m.custom.available_locations', 'filter.v.m.custom.available_locations',
      'preview_theme_id', '_ab', '_fd', '_sc'].forEach(function (key) {
      if (params.has(key) && !event.formData.has(key)) {
        params.getAll(key).forEach(function (value) { event.formData.append(key, value); });
      }
    });
    if (params.get('filter.v.availability') === '1' && !event.formData.has('filter.v.availability')) {
      event.formData.set('filter.v.availability', '1');
    }
    event.formData.delete('page');
    if (form.dataset.libasBandChanged === 'true') {
      priceParams.forEach(function (key) { event.formData.delete(key); });
    } else if (form.dataset.libasPriceMode === 'bands') {
      // Keep bookmarked min/max limits even if another script resets hidden inputs.
      priceParams.forEach(function (key) {
        if (params.has(key)) event.formData.set(key, params.get(key));
      });
    }
    if (form.dataset.libasPriceMode !== 'bands') event.formData.delete(bandParam);
  }, true);
})();
